import EditableCell from './EditableCell.vue'

export default EditableCell